import { render } from "./usuarios-list.vue?vue&type=template&id=06b64223"
import script from "./usuarios-list.vue?vue&type=script&lang=js"
export * from "./usuarios-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__